/** A responsive header control can disappear; give keyboard focus a visible destination. */
export function focusPublicMain(): void {
  const main = document.querySelector<HTMLElement>("main");
  if (!main) return;
  main.tabIndex = -1;
  main.focus({ preventScroll: true });
}

// A cross-page section target may not exist until the lazy homepage mounts. This intent
// lives only for the current navigation; no URL, field value or user identifier is recorded.
let pendingSectionFocus: string | null = null;

export function preparePublicNavigationFocus(href: string): void {
  pendingSectionFocus = href.startsWith("/#") ? href.slice(1) : null;
}

export function consumePublicSectionFocus(hash: string): boolean {
  const shouldFocus = pendingSectionFocus === hash;
  pendingSectionFocus = null;
  return shouldFocus;
}
